import {Component, Inject, OnInit} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';

@Component({
    selector: 'app-select-client-type-dialog',
    templateUrl: './select-client-type-dialog.component.html',
    styleUrls: ['./select-client-type-dialog.component.scss'],
    standalone: false
})
export class SelectClientTypeDialogComponent implements OnInit {

  public type = 'person';

  public title;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<any>,
  ) {
    this.title = data.title;
  }

  static open(dialog: MatDialog, title?: string) {
    return dialog.open(SelectClientTypeDialogComponent, {
      width: '500px',
            disableClose: true,
      data: {
        title,
      }
    });
  }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close(false);
  }

  submit() {
    this.dialogRef.close(this.type);
  }

  selectType(type: string) {
    this.type = type;
    this.submit();
  }
}
